import { Component, computed, effect, signal } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.html',
})
export default class Home {
    protected readonly count = signal(0);
    protected readonly doubleCount = computed(() => this.count() * 2);

    constructor() {
        effect(() => {
            console.log(`Double count changed to: ${this.doubleCount()}`);
        });
    }

    decrement() {
        this.count.set(this.count() - 1);
    }

    increment() {
        this.count.set(this.count() + 1);
    }
}
